import { defineMessages } from 'react-intl';

export default defineMessages({
  tableHeaderName: {
    id: 'frontbucket.branches.tableHeaderName',
    description: 'Text for "name" column header in branch list',
    defaultMessage: 'Branch',
  },
  tableHeaderBehind: {
    id: 'frontbucket.branches.tableHeaderBehind',
    description: 'Text for "behind" column header in branch list',
    defaultMessage: 'Behind',
  },
  tableHeaderAhead: {
    id: 'frontbucket.branches.tableHeaderAhead',
    description: 'Text for "ahead" column header in branch list',
    defaultMessage: 'Ahead',
  },
  tableHeaderUpdated: {
    id: 'frontbucket.branches.tableHeaderUpdated',
    description: 'Text for "updated" column header in branch list',
    defaultMessage: 'Updated',
  },
  tableHeaderPullRequest: {
    id: 'frontbucket.branches.tableHeaderPullRequest',
    description: 'Text for "Pull request" column header in branch list',
    defaultMessage: 'Pull request',
  },
  tableHeaderBuilds: {
    id: 'frontbucket.branches.tableHeaderBuilds',
    description: 'Text for "Builds" column header in branch list',
    defaultMessage: 'Builds',
  },
  staleBranchesDeleteCTA: {
    id: 'frontbucket.branches.staleNotificatoinDeleteCTA',
    description: 'Text for CTA notification to delete stale branches',
    defaultMessage:
      'Use the "Delete Multiple" option to quickly clean up your repo',
  },
});
